import OrdersTable from './OrdersTable';
import { withI18n } from 'react-i18next';

export default withI18n()(OrdersTable);
